import Typography from '@mui/material/Typography'
import { FormSectionProps } from '../../interfaces/form'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

import FormWizard from '../wizard'
import FormField from '../../components/FormField'

const Postcode = ({ validate }: FormSectionProps) => {
  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 7, mb: 12, display: 'flex' }} flexDirection="column">
        <FormWizard.Page validate={validate}>
          <Typography variant="h3" sx={{ mb: 4 }}>
            What's your postcode? We estimate your living expenses based on
            averages in the area
          </Typography>
          <FormField
            id="postcode"
            name="postcode"
            type="text"
            style={{ marginBottom: '40px' }}
          />
        </FormWizard.Page>
      </Box>
    </Container>
  )
}

export default Postcode
